import React, { FC, useEffect } from 'react'

export interface ProductFooterProps {
  show?: boolean
  type?: 'fixed' | 'collapsable'
}

const ProductFooter: FC<ProductFooterProps> = ({
  children,
  show,
  type = 'fixed',
}) => {
  const mustOpen = () => {
    switch (type) {
      case 'fixed':
        return true
      case 'collapsable':
        return show
    }
  }
  const open = mustOpen()
  const [height, setHeight] = React.useState<string | number>(0)
  const ref = React.useRef<HTMLDivElement>(null)

  const openContent = () => {
    if (ref.current !== null) {
      ref.current.style.height = 'auto'
      const childrenHeight = ref.current.offsetHeight
      ref.current.style.height = '0'
      ref.current.offsetHeight
      setHeight(childrenHeight)
    }
  }

  const closeContent = () => {
    if (ref.current !== null) {
      const childrenHeight = ref.current.offsetHeight

      setHeight(childrenHeight)
      window.requestAnimationFrame(() => setHeight(0))
    }
  }

  const handleTransitionEnd = () => {
    setHeight(open ? 'auto' : 0)
  }

  useEffect(
    function collapsibleContentUpdate() {
      if (open) {
        openContent()
      } else {
        closeContent()
      }
    },
    [open]
  )

  useEffect(function setProperlyHeightWhileMount() {
    if (ref.current !== null && open) {
      ref.current.style.height = 'auto'
      const childrenHeight = ref.current.offsetHeight
      setHeight(childrenHeight)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const childrenContainerStyle = {
    height,
    overflow: 'hidden',
    transition: 'height 250ms ease-in-out',
  }

  return (
    <div
      ref={ref}
      style={childrenContainerStyle}
      onTransitionEnd={handleTransitionEnd}
    >
      {children}
    </div>
  )
}

export default ProductFooter
